<div class="powerBi" [style]=style #reportContainer></div>
